// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"left__wrap--2Vqwl"};